import { FC } from 'react';
import { FormikValues } from 'formik';
import classNames from 'classnames';
import { InputRadioGroup } from '@lambdacurry/component-library';
import { MedusaProductVariant } from 'lib/home/generated/types/api';
import { MealPlanInput } from './MealPlanInput';
import './meal-plans-input-group.scss';

export interface MealPlansInputGroupProps {
  className?: string;
  name: string;
  plans: MedusaProductVariant[];
  values: FormikValues;
}

export const MealPlansInputGroup: FC<MealPlansInputGroupProps> = ({ className, name, plans, values }) => (
  <InputRadioGroup className={classNames(`meal-plans-input-group`, className)} name={name}>
    {plans.map(plan => (
      <MealPlanInput
        amount={plan.prices[0].amount}
        checked={values[name] === plan.id}
        id={`${name}.${plan.id}`}
        key={plan.id}
        title={plan.product.title}
        value={plan.id}
      />
    ))}
  </InputRadioGroup>
);
